module.exports = __webpack_public_path__ + "img/to_ineligble.b630f04d.svg";